const mesesList = [
   {
      id: 1,
      descricao: 'Janeiro',
      sigla: 'Jan',
      mes: '01',
      ordem: 1,
   },
   {
      id: 2,
      descricao: 'Fevereiro',
      sigla: 'Fev',
      mes: '02',
      ordem: 2,
   },
   {
      id: 3,
      descricao: 'Março',
      sigla: 'Mar',
      mes: '03',
      ordem: 3,
   },
   {
      id: 4,
      descricao: 'Abril',
      sigla: 'Abr',
      mes: '04',
      ordem: 4,
   },
   {
      id: 5,
      descricao: 'Maio',
      sigla: 'Mai',
      mes: '05',
      ordem: 5,
   },
   {
      id: 6,
      descricao: 'Junho',
      sigla: 'Jun',
      mes: '06',
      ordem: 6,
   },
   {
      id: 7,
      descricao: 'Julho',
      sigla: 'Jul',
      mes: '07',
      ordem: 7,
   },
   {
      id: 8,
      descricao: 'Agosto',
      sigla: 'Ago',
      mes: '08',
      ordem: 8,
   },
   {
      id: 9,
      descricao: 'Setembro',
      sigla: 'Set',
      mes: '09',
      ordem: 9,
   },
   {
      id: 10,
      descricao: 'Outubro',
      sigla: 'Out',
      mes: '10',
      ordem: 10,
   },
   {
      id: 11,
      descricao: 'Novembro',
      sigla: 'Nov',
      mes: '11',
      ordem: 11,
   },
   {
      id: 12,
      descricao: 'Dezembro',
      sigla: 'Dez',
      mes: '12',
      ordem: 12,
   },
]

export default mesesList